import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './FormComponent.css';
import logo from '../reshipes-logo.jpg';
import PaymentInfo from './PaymentInfo';

const OrderSummaryPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { items, total, deliveryFee } = location.state;

  return (
    <div className="page-wrapper">
      <div className="form-header">
        <img src={logo} alt="Reshipes Logo" className="form-logo" />
        <h1>Reshipes Bakery</h1>
      </div>
      <div className="form-section" style={{ maxWidth: 600 }}>
        <h3>Order Confirmed</h3>
        <p style={{ color: '#5a4030', marginBottom: 20 }}>
          Thank you for your order! We'll be in touch with pickup details.
        </p>
        <h4>Order Summary</h4>
        {items.map((item, index) => (
          <div key={index} className="order-summary-line">
            <span>{item.size} {item.foodName} × {item.quantity}</span>
            <span>${item.subtotal.toFixed(2)}</span>
          </div>
        ))}
        {deliveryFee > 0 && (
          <div className="order-summary-line">
            <span>Delivery fee</span>
            <span>${deliveryFee.toFixed(2)}</span>
          </div>
        )}
        <div className="order-total">
          <span>Total</span>
          <span>${total.toFixed(2)}</span>
        </div>
        <PaymentInfo />
        <button
          onClick={() => navigate('/')}
          style={{
            marginTop: 28,
            width: '100%',
            padding: '14px',
            background: '#c4762a',
            color: '#fff',
            border: 'none',
            borderRadius: 50,
            fontSize: '1rem',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Place a New Order
        </button>
      </div>
    </div>
  );
};

export default OrderSummaryPage;
